import useInitializeApplicationAdvancedForm from './useInitializeApplicationAdvancedForm'

export default useInitializeApplicationAdvancedForm
